// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1gdAD","rootSuccess":"CompleteLink_rootSuccess__2sbxh","rootFailure":"CompleteLink_rootFailure__2Wkvn","isDisabled":"CompleteLink_isDisabled__13NHw"};